import { type Entry } from '@clubspark-node/clubspark-tennis-types';
import { entryStatusConstants, tools as factoryTools } from 'tods-competition-factory';

import { type TournamentDeskUISettings } from 'components/dialogs/draw/publicDrawDisplaySettings/types';

const { ALTERNATE } = entryStatusConstants;

export const getRelevantDrawIds = ({ participantIds, eventId, tournamentEngine }) => {
  const { flightProfile } = tournamentEngine.getFlightProfile({ eventId });
  return factoryTools.unique(
    flightProfile?.flights
      ?.filter(({ drawEntries }) => drawEntries.find(({ participantId }) => participantIds.includes(participantId)))
      ?.map(({ drawId }) => drawId) || [],
  );
};

const getEntryStatusOrder = (entries: Entry[], entry: Entry) => {
  const entryStatus = entries?.find(({ participantId }) => participantId === entry.participantId)?.entryStatus
  return entryStatus  === ALTERNATE ? Number.MAX_SAFE_INTEGER : entryStatus.charCodeAt(0);
}

export const entryStatusSort = (entries: Entry[]) => (a: Entry, b: Entry) =>
  getEntryStatusOrder(entries, a) - getEntryStatusOrder(entries, b);

export const entryPositionValue = (entryPosition: Entry['entryPosition']) =>
  isNaN(entryPosition) ? Infinity : entryPosition;

export const entryPositionSort = (a: Entry, b: Entry) =>
  entryPositionValue(a.entryPosition) - entryPositionValue(b.entryPosition);

export const getIsUpdateAlternatesColumns = ({
  isTeam,
  isTeamPlayersTable,
  selectedColumns,
  tournamentDeskUI,
}: {
  isTeam: boolean;
  isTeamPlayersTable: boolean;
  selectedColumns: string[];
  tournamentDeskUI: TournamentDeskUISettings;
}) => {
  if (
    isTeamPlayersTable &&
    JSON.stringify(selectedColumns) === JSON.stringify(tournamentDeskUI?.teamsAlternatePlayersColumns)
  )
    return;
  if (
    isTeam &&
    !isTeamPlayersTable &&
    JSON.stringify(selectedColumns) === JSON.stringify(tournamentDeskUI?.teamsAlternateColumns)
  )
    return;
  if (!isTeam && JSON.stringify(selectedColumns) === JSON.stringify(tournamentDeskUI?.singlesDoublesAlternateColumns))
    return;

  return true;
};

export const getIsUpdateQualifyingColumns = ({
  isTeam,
  selectedColumns,
  tournamentDeskUI,
}: {
  isTeam: boolean;
  selectedColumns: string[];
  tournamentDeskUI: TournamentDeskUISettings;
}) => {
  if (isTeam && JSON.stringify(selectedColumns) === JSON.stringify(tournamentDeskUI?.teamsQualifyingColumns)) return;
  if (!isTeam && JSON.stringify(selectedColumns) === JSON.stringify(tournamentDeskUI?.singlesDoublesQualifyingColumns))
    return;

  return true;
};

export const getIsUpdateSelectedColumns = ({
  isTeam,
  isTeamPlayersTable,
  selectedColumns,
  tournamentDeskUI,
}: {
  isTeam: boolean;
  isTeamPlayersTable: boolean;
  selectedColumns: string[];
  tournamentDeskUI: TournamentDeskUISettings;
}) => {
  if (
    isTeamPlayersTable &&
    JSON.stringify(selectedColumns) === JSON.stringify(tournamentDeskUI?.teamsAvailablePlayersColumns)
  )
    return;
  if (
    isTeam &&
    !isTeamPlayersTable &&
    JSON.stringify(selectedColumns) === JSON.stringify(tournamentDeskUI?.teamsSelectedColumns)
  )
    return;
  if (!isTeam && JSON.stringify(selectedColumns) === JSON.stringify(tournamentDeskUI?.singlesDoublesSelectedColumns))
    return;

  return true;
};
